var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 16 16",
    fill: "none",
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "Package-Check--Streamline-Lucide",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Package Check Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 10 1.25 1.25 2.5 -2.5",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.25V5a1.25 1.25 0 0 0 -0.625 -1.08125l-4.375 -2.5a1.25 1.25 0 0 0 -1.25 0l-4.375 2.5A1.25 1.25 0 0 0 1.875 5v5a1.25 1.25 0 0 0 0.625 1.08125l4.375 2.5a1.25 1.25 0 0 0 1.25 0l1.25 -0.7124999999999999",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.6875 2.6687499999999997 5.625 3.21875",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05625 4.375 7.5 7.5l5.4437500000000005 -3.125",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.5 13.75 0 -6.25",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageCheck);
export default __webpack_public_path__ + "static/media/package-check.ee7611435bf807caf082c92454190175.svg";
export { ForwardRef as ReactComponent };